import m from "mithril";

export const fetchSession = async (): Promise<{ data: { active: boolean } }> => {
  return m.request({
    method: "get",
    url: "/auth/userinfo",
  });
};
